export const GET_PROGRAM_DETAILS = "GET_PROGRAM_DETAILS";
